/**
 * Status and priority color mapping for chips/badges (MUI color names or hex).
 */
export const statusColors = {
    new: 'info',
    quoted: 'warning',
    accepted: 'primary',
    in_progress: 'secondary',
    completed: 'success',
    cancelled: 'error',
    closed: 'error',
};

export const priorityColors = {
    low: 'success',
    medium: 'info',
    high: 'warning',
    urgent: 'error',
};

/** Get MUI chip color for a status name (case-insensitive). */
export const getStatusColor = (status) => {
    if (!status) return 'default';
    const key = String(status).toLowerCase().replace(/\s+/g, '_');
    return statusColors[key] || 'default';
};

/** Get MUI chip color for a priority name (case-insensitive). */
export const getPriorityColor = (priority) => {
    if (!priority) return 'default';
    const key = String(priority).toLowerCase().replace(/\s+/g, '_');
    return priorityColors[key] || 'default';
};

/** Format status/priority label for display (e.g. "in_progress" -> "In Progress"). */
export const formatStatusLabel = (value) => {
    if (value == null || value === '') return '';
    const str = String(value).trim();
    return str
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

/** Get MUI chip color for service order status. */
export const getServiceOrderStatusChipColor = (status) => getStatusColor(status);

/** Get MUI chip color for service order priority. */
export const getServiceOrderPriorityChipColor = (priority) => getPriorityColor(priority);

/** Get MUI chip color for report status. */
export const getReportStatusColor = (status) => getStatusColor(status);

export default statusColors;
